<template>
  <teleport to="body">
    <div v-if="visible" class="oido-popover-backdrop" @click="$emit('dismiss', null)"></div>
    <div v-if="visible" ref="popoverEl" class="oido-popover" :style="positionStyle">
      <slot></slot>
    </div>
  </teleport>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    anchorEvent: {
      type: [Object, null],
      default: null
    }
  },
  emits: ['dismiss'],
  data() {
    return {
      adjustedPosition: null
    }
  },
  computed: {
    positionStyle() {
      if (this.adjustedPosition) return this.adjustedPosition
      if (!this.anchorEvent) return {}
      // Initial render off-screen to measure
      return { top: '-9999px', left: '-9999px' }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.adjustedPosition = null
        this.$nextTick(() => this.calculatePosition())
      } else {
        this.adjustedPosition = null
      }
    }
  },
  methods: {
    calculatePosition() {
      if (!this.anchorEvent || !this.$refs.popoverEl) return
      let x = this.anchorEvent.clientX || 0
      let y = this.anchorEvent.clientY || 0
      let el = this.$refs.popoverEl
      let popoverWidth = el.offsetWidth
      let popoverHeight = el.offsetHeight
      let winWidth = window.innerWidth
      let winHeight = window.innerHeight

      let style = {}

      // Vertical: open downward or upward based on available space
      if (y + popoverHeight > winHeight && y - popoverHeight > 0) {
        style.top = (y - popoverHeight) + 'px'
      } else {
        style.top = Math.min(y, winHeight - popoverHeight - 8) + 'px'
      }

      // Horizontal: open left or right based on available space
      if (x - popoverWidth < 0) {
        style.left = x + 'px'
      } else {
        style.left = (x - popoverWidth) + 'px'
      }

      this.adjustedPosition = style
    }
  }
}
</script>

<style>
.oido-popover-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
}

.oido-popover {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.oido-popover > .oido-button {
  padding: 0.7rem 1rem;
  font-size: 0.85rem;
  border-radius: 0;
  justify-content: flex-start;
}

.oido-popover > .oido-button:hover {
  background-color: #f5f5f5;
}

.oido-popover > .oido-button + .oido-button {
  border-top: 1px solid #eee;
}
</style>
